export default function imageUrl(url, options) {
  if (url.indexOf('https://d3s6jo6q0vpov5.cloudfront.net/') == 0) {
    const params = ['f_auto,q_auto,c_limit,dpr_auto', options].filter(Boolean).join(',')
    return url.replace('https://d3s6jo6q0vpov5.cloudfront.net/', `https://res.cloudinary.com/hz4hxqvhc/image/upload/${params}/formbeat/`)
  } else {
    return url
  }
}
